import { getFormHash } from '@tf/shared';
import type { ConnectedEntity, StructureEntity } from '@/components/structure/useStructureEntities';

type FormInfo = ConnectedEntity['forms'][number];

const isSameForm = (a: FormInfo, b: FormInfo) =>
	a.form.name === b.form.name && getFormHash(a.form) === getFormHash(b.form);

export const mergeConnectedEntitiesForms = (entities: StructureEntity[]) => {
	const formsByEntityId: Record<string, FormInfo[]> = {};
	const clonedEntities = structuredClone(entities);

	for (const entity of clonedEntities) {
		for (const connections of entity.connections) {
			for (const connectedEntity of connections?.connectedEntities ?? []) {
				const forms = formsByEntityId[connectedEntity.entityId] ?? [];
				formsByEntityId[connectedEntity.entityId] = forms;

				for (const formInfo of connectedEntity.forms) {
					if (forms.some((f) => isSameForm(f, formInfo))) continue;
					forms.push(formInfo);
				}
			}
		}
	}

	for (const entity of clonedEntities) {
		if (formsByEntityId[entity.entityId]) {
			entity.forms.push(...formsByEntityId[entity.entityId]);
		}
	}

	return clonedEntities;
};
